import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit';

import { Divider } from '../../Divider';

import * as styles from './FieldRowGroupTitle.css';
import clsx from 'clsx';

interface IFieldRowGroupTitleProps {
  title: React.ReactNode;
  withoutPadding?: boolean;
}

export const FieldRowGroupTitle: React.FC<IFieldRowGroupTitleProps> = ({ title, withoutPadding }) => (
  <div className={clsx(styles['container'], withoutPadding && styles['no-padding'])}>
    <div className={styles['heading-wrapper']}>
      <UIHeading3>{title}</UIHeading3>
    </div>
    <Divider />
  </div>
);
